import React from 'react';
import Browse from '../Browse/Browse';
import TaxonomyTree from './TaxonomyTree';
import TaxonomyMetricsTable from './TaxonomyMetricsTable';
import TaxonomyPath from './TaxonomyPath';

const BrowseByTaxonomy = props => (
  <Browse
    {...props}
    title='Browse by Taxonomy'
    baseUrl='/taxonomy/'
    TreeComponent={TaxonomyTree}
    BreadcrumbPathComponent={TaxonomyPath}
    MetricsTableComponent={TaxonomyMetricsTable}
  />
);

export default BrowseByTaxonomy;
